// extracted by mini-css-extract-plugin
export default {"confidentialNote":"BrandProfile-module__confidentialNote--3793"};